import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { getAnnouncementTableColumns } from './columns'

import { DataTable } from '@/components/ui/data-table'
import { useAuth } from '@/providers/AuthContextProvider'
import { RoutePaths } from '@/routes/routes'
import { useQueryGetAnnouncements } from '@/services/announcements.service'
import { isPermitted, Permissions } from '@/utils/permission-manager'

const AnnouncementList = () => {
  const { userData } = useAuth()
  const navigate = useNavigate()
  const { data, isLoading, isError } = useQueryGetAnnouncements()
  const columns = useMemo(() => getAnnouncementTableColumns(), [])
  const canManage = Boolean(
    userData && isPermitted(Permissions.MANAGE_ANNOUNCEMENTS, userData)
  )

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold text-primary">Announcements</h1>
        <p className="text-sm text-muted-foreground">
          Legal notices shown as a non-blocking banner in the 360 portal, e.g.
          subprocessor list changes. Org admins acknowledge them; the log below
          is the evidence per organization.
        </p>
      </div>
      {isError && (
        <p className="text-sm text-destructive">
          Could not load announcements. The announcements API may not be
          deployed on this stage yet.
        </p>
      )}
      <DataTable
        allowCreate={canManage}
        columns={columns}
        data={data ?? []}
        defaultSorting={[{ id: 'created_at', desc: true }]}
        hideColumnFilters
        isLoading={isLoading}
        onRowClick={(row) => {
          if (row.original.id) {
            navigate(`${RoutePaths.ANNOUNCEMENTS}/${row.original.id}`)
          }
        }}
        tableConfigName="announcements"
        toolbarProps={{
          filterPlaceholder: 'Search list version...'
        }}
      />
    </div>
  )
}

export default AnnouncementList
